import { Hash } from "viem";
import { JAM_BALANCE_MANAGER, JAM_CONTRACT, PMM_CONTRACT } from "../../config/consts";
import { ApprovalStore } from "../../store/approvals/ApprovalsStore";
import { GlobalStore } from "../../store/global/GlobalStore";
import { isBestQuotePmm } from "../../utils/quoteUtils";

export const useApprovalTarget = (): Hash | undefined => {
  const { quote } = GlobalStore.useState(s => {
    return { quote: s.quote };
  });
  const approvalTarget = ApprovalStore.useState(s => s.approvalTarget);

  if (approvalTarget) {
    return approvalTarget;
  }

  if (quote) {
    return isBestQuotePmm(quote.routeType) ? PMM_CONTRACT : JAM_CONTRACT;
  }

  return undefined;
};

// Non-hook version of useApprovalTarget

export const getApprovalTarget = (): Hash | undefined => {
  const quote = GlobalStore.getRawState().quote;
  const approvalTarget = ApprovalStore.getRawState().approvalTarget;

  if (approvalTarget) {
    return approvalTarget;
  }

  if (quote) {
    return isBestQuotePmm(quote.routeType) ? PMM_CONTRACT : JAM_BALANCE_MANAGER;
  }

  return undefined;
};
